import api from '@/api';

export default {
  namespaced: true,
  state: () => ({ items: [], loading: false, q: '' }),
  getters: {
    all: s => s.items
      .filter(i => !s.q || i.name.toLowerCase().includes(s.q.toLowerCase())),
    active: s => s.items.filter(i => i.is_active),
    loading: s => s.loading,
  },
  mutations: {
    setItems(s, v){ s.items = v || []; },
    setLoading(s, v){ s.loading = !!v; },
    setQuery(s, v){ s.q = v || ''; },
  },
  actions: {
    async fetchAll({ commit }) {
      commit('setLoading', true);
      try {
        const { data } = await api.get('/exam-types');
        commit('setItems', data.data ?? data);
      } finally { commit('setLoading', false); }
    },
    async create({ dispatch }, payload) {
      await api.post('/exam-types', payload);
      await dispatch('fetchAll');
    },
    async update({ dispatch }, { id, ...payload }) {
      await api.put(`/exam-types/${id}`, payload);
      await dispatch('fetchAll');
    },
    async remove({ dispatch }, id) {
      await api.delete(`/exam-types/${id}`);
      await dispatch('fetchAll');
    },
  },
};
